<template>
  <div class="line-content" style="width: 100%">
    <div
      class="line-content--item"
      flex
      v-for="(item, idx) in optionsList"
      :key="idx"
    >
      <div
        flex
        v-for="(option, index) in item"
        :key="index"
        class="option-item"
      >
        <div style="margin-right: 10px" class="questionSeq">
          {{ index === 0 ? uppercaseStr[idx] : lowercaseStr[idx] }}
        </div>
        <bc-view-common
          placeholder="点击编辑选项"
          :border="false"
          style="flex: 1; min-width: 0"
          :content="option.content"
          :fileInfo="option.fileInfo"
        ></bc-view-common>
      </div>
    </div>
    <!--    <div class="line-content&#45;&#45;item">-->
    <!--      <div flex v-for="(item, index) in optionsList.right" :key="index" class="option-item">-->
    <!--        <div style="margin-right: 10px;line-height: 40px">{{ item.title }}</div>-->
    <!--        <bc-view-common  placeholder="点击编辑选项"-->
    <!--                         :content="item.content" :fileInfo="item.fileInfo"-->
    <!--        ></bc-view-common>-->
    <!--      </div>-->

    <!--    </div>-->
  </div>
</template>

<script>
const lowercaseStr = "abcdefghijklmnopqrstuvwxyz".split("");
const uppercaseStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
export default {
  name: "bc-line-question-view",
  props: {
    options: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    options: {
      handler(val) {
        this.optionsList = val;
      },
      immediate: true,
    },
  },
  data() {
    return {
      lowercaseStr,
      uppercaseStr,
      optionsList: [],
    };
  },
};
</script>

<style scoped lang="scss">
.line-content {
  width: 100%;
  .line-content--item {
    flex: 1;
    ::v-deep .stem-content {
      height: 100%;
    }
  }

  & + .line-content {
    margin-top: 10px;
  }
  //.line-content--item + .line-content--item {
  //  margin-left: 100px;
  //}
}
//.line-content--item + .line-content--item {
//}
.option-item + .option-item {
  //margin-top: 10px;
}
.create-option {
  width: 100%;
  margin-top: 10px;
  border-style: dashed !important;
}

.option-item {
  flex: 1;
  min-width: 0;
}

.option-item + .option-item {
  margin-left: 100px;
}
.option-item {
  margin-bottom: 10px;
  background: #fbfbfb;
  border-radius: 6px;
  padding-left: 16px;
  ::v-deep .stem-content {
    &.no-border {
      padding: 8px 14px !important;
    }
  }
}

.questionSeq {
  line-height: 44px;
}
</style>
